import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-beneficiary-profile-data',
  templateUrl: './beneficiary-profile-data.component.html',
  styleUrls: ['./beneficiary-profile-data.component.scss']
})
export class BeneficiaryProfileDataComponent implements OnInit, OnDestroy {
  selectedState = 'simple';
  caption: string = '';
  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.caption = this.router.getCurrentNavigation().extras.state ?
      this.router.getCurrentNavigation().extras.state.profileName : this.caption;
   }

  ngOnInit(): void {
  } 
  onChange($event) {
    this.selectedState = $event.value;
    if (this.selectedState === 'complete') {
      this.redirectToProfile();
    }
  }

  redirectToProfile() {
    this.router.navigate(['../profile'], { state: { profileName: this.caption, redirectUrl: '', redirectPage: '' }, relativeTo: this.route });
  }

  ngOnDestroy() {
    if (!(this.router.routerState.snapshot.url.indexOf('profile') > -1)) {
      sessionStorage.removeItem('bene-profile-viewMode');
      sessionStorage.removeItem('listBeneficiaryId');
    }
  }
}
